import api from "./api";
import { ApiResponse } from "./auth.service";

export const getJobTypes = (): ApiResponse<any> => api.get("/configs/job-types").then(res => res.data);

export const getRanks = (job_type_id: string): ApiResponse<any> => api.get("/configs/job-type-ranks?job_type_id=" + job_type_id).then(res => res.data);

const getOrigin = () => {
  if (typeof window === "undefined") return "";
  return `${window.location.protocol}//${window.location.hostname}`;
};

export const getFrontendLandingUrl = () => getOrigin();

export const getFrontendPortalUrl = () => {
  const origin = getOrigin();
  return origin ? `${origin}/portal` : "";
};
